import React, { useEffect, useRef, useState } from 'react'
import { ApiService, URl_Server } from '../components';

import SearchIcon from '@mui/icons-material/Search';

import { toast } from "react-toastify";
import { ImagenesGlobal } from '../components/global/ImagenesGlobal';
import { useProovedorData } from '../components'
import { ModalForAll } from '../components/global/ModalForAll';
import { ModalViewProduct } from '../components/empresa_uno_comp/Modal_view_product';
import { throttle } from "lodash";
import { useNavigate, useParams } from 'react-router-dom';
import MyCompanyUpdate from '../components/MyCompanyUpdate';
import { Preloader } from '../components/Preloader';

const token = localStorage.getItem("token");

const GlobalProducts = () => {
    const navigate = useNavigate();

    const [loadingGP, setLoadingGP] = useState(false);
    const refObjectPag = useRef({ page: 1, request_dt: null, number_results: 0 });
    const [listadoProductos, setListadoProductos] = useState([]);

    const { data_user, loadImageS, main_data, temporalNewCompany, setTemporalNewCompany, reloadMyCompanys, setShowLogin, returnCurrency } = useProovedorData() ?? [];
    const search_disabled = data_user?.authCode == null;
    const refProductList = useRef(null);
    const refBusqueda = useRef(null);

    const [dataModal, setDataModal] = useState(false);
    const [currentOption, setCurrentOption] = useState('inicio');

    const [cacheResults, setCacheResults] = useState({});

    const [listProductFiltered, setListProductFiltered] = useState([]);
    const [listProducts_Brands, setListProducts_Brands] = useState({})
    const [listProducts_Categories, setListProducts_Categories] = useState({})
    const [stateModalAddCompany, setStateModalAddCompany] = useState(false);

    async function loadGlobalProducts() {
        const { page, request_dt, number_results } = refObjectPag.current;
        // contenedorRef.current.scrollTop = contenedorRef.current.scrollHeight; SOLUCIONAR
        if (page == 1 || (page > 1 && number_results == 100)) {
            setLoadingGP(true);
            refState.current = true;
            try {
                const request_products = await ApiService.fetchData(`api/global/products/list?page=${page + (request_dt ? '&request_dt=' + request_dt : '')}`);

                if (request_products?.request_dt) {
                    refObjectPag.current = {
                        page: (request_products?.current_page ?? 1) + 1,
                        request_dt: request_products?.request_dt,
                        number_results: request_products?.data_count ?? 0
                    };

                    const ListResult = listadoProductos.concat(request_products.result);
                    setListadoProductos((current_array) => current_array.concat(request_products.result));

                    const arrayBrands = {};
                    const arrayCategories = {};

                    ListResult.forEach(obj => {
                        if (!arrayBrands[obj.brand_name]) {
                            arrayBrands[obj.brand_name] = [];
                        }
                        arrayBrands[obj.brand_name].push(obj);

                        if (!arrayCategories[obj.category_name]) {
                            arrayCategories[obj.category_name] = [];
                        }
                        arrayCategories[obj.category_name].push(obj);
                    });
                    setListProducts_Brands(arrayBrands);
                    setListProducts_Categories(arrayCategories);
                }
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setLoadingGP(false);
                refState.current = false;
            }
        } else {
            toast.info("No quedan mas productos");
        }
    }

    const refState = useRef(false);

    const handleScroll = throttle(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const windowHeight = window.innerHeight;
        const currentHeight = refProductList?.current ? refProductList.current?.offsetHeight : 0; //Restar aqui
        const totalScroll = scrollTop + windowHeight;

        if (currentHeight > 0 && totalScroll > currentHeight && refState.current == false) {
            loadGlobalProducts();
        }
    }, 500);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        loadGlobalProducts();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    function handleModal(obj) {
        if (obj) setDataModal(obj);
        else setDataModal(false);
    }

    async function searchProducts(event) {
        if (search_disabled) {
            console.warn("Debes Iniciar sesión para usar esta funcionalidad");
            setShowLogin(true);
            return;
        }

        if (event == null) return;

        const current_val = String(event.target.value);
        if (current_val.length == 0) {
            setCurrentOption('inicio');
            return
        }

        if (current_val.length < 3) return;
        // Abort previous search if there is one
        if (refBusqueda.current) {
            refBusqueda.current.abort(`Busqueda de "${current_val}" cancelada por el delay del buscador`);
            refBusqueda.current = null;  // Reset the ref after aborting
        }

        // If the result is in cache, use it
        if (cacheResults?.[current_val]) {
            setListProductFiltered(cacheResults[current_val]);
        } else {
            // Create a new AbortController for the new request
            const controller = new AbortController();
            refBusqueda.current = controller;

            try {
                setLoadingGP(true);
                const request_sp = await fetch(`${URl_Server()}api/global/products/search?text=${current_val}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    signal: controller.signal,
                });

                const response = await request_sp.json();

                setListProductFiltered(response);

                // Cache the results for future use
                setCacheResults((current_object) => {
                    const temp_object = { ...current_object };
                    temp_object[current_val] = response;
                    return temp_object;
                });
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error("Error en la búsqueda", error);
                }
            } finally {
                setLoadingGP(false);
            }
        }

        setCurrentOption(current_val.length > 0 ? 'filter' : 'inicio');
    }

    function openProducts() {
        if ((main_data?.companys ?? []).length > 0) navigate(`administrar/negocio/productos/${main_data?.companys[0].nit}`);
        else setStateModalAddCompany(true);
    }

    return (
        <div className='home-products-global'>
            <div className='head-hpg'>
                <ul>
                    <li><button onClick={() => setCurrentOption('inicio')} className={'default-buttons ' + (currentOption == 'inicio' ? 'btn-selected' : '')}>Inicio</button></li>
                    <li><button onClick={() => setCurrentOption('marcas')} className={'default-buttons ' + (currentOption == 'marcas' ? 'btn-selected' : '')}>Categorías</button></li>
                    <li><button onClick={() => setCurrentOption('categorias')} className={'default-buttons ' + (currentOption == 'categorias' ? 'btn-selected' : '')}>Marcas</button></li>
                </ul>

                <span className='search-hpg'>
                    <SearchIcon style={{ fontSize: '30px', color: 'var(--empresa-color)' }} />
                    <input
                        type='text'
                        placeholder={'Buscar producto(' + (listadoProductos.length) + ')...'}
                        readOnly={search_disabled}
                        onChange={searchProducts}
                        onClick={() => searchProducts(null)}
                    />
                </span>

                {!search_disabled ? (<button className='default-buttons shadow-lvl6' onClick={openProducts}>Vender</button>) : (<span></span>)}
            </div>

            <div className='gallery-products-global' style={{ display: currentOption == 'filter' ? (listProductFiltered.length > 0 ? 'grid' : 'block') : 'none' }}>
                {
                    listProductFiltered.length > 0 ? (listProductFiltered && listProductFiltered.map((objs) => (
                        <div className='card-product-global shadow-lvl6' onClick={() => handleModal(objs)} >
                            <div>
                                <ImagenesGlobal
                                    url={objs?.img_list.length > 0 ? objs.img_list[0] : null}
                                    loadImageS={loadImageS}
                                    type={'picture'}
                                    key={objs?.code + objs?.company_id}
                                />
                            </div>

                            <div>
                                <span className='limited-text normal-black'>{objs?.product_name ?? 'Caragando Nombre...'}</span>
                                <span className='text-bold' style={{ flexShrink: 0, color: 'green', fontSize: '14px' }}>{returnCurrency(objs?.sale_price ?? 0.00, objs?.currency)}</span>
                            </div>

                        </div>
                    ))) : (<span style={{ textAlign: 'center', display: 'block', width: '100%' }}>Producto ingresado no existe actualmente...</span>)
                }
            </div>

            <div className='gallery-products-global' style={{ display: currentOption == 'inicio' ? 'grid' : 'none' }} ref={refProductList}>
                {
                    listadoProductos && listadoProductos.map((objs) => (
                        <div className='card-product-global shadow-lvl6' onClick={() => handleModal(objs)}>
                            <div>
                                <ImagenesGlobal
                                    url={objs?.img_list.length > 0 ? objs.img_list[0] : null}
                                    loadImageS={loadImageS}
                                    type={'picture'}
                                    key={objs?.code + objs?.company_id}
                                />
                            </div>

                            <div>
                                <span className='limited-text normal-black'>{objs?.product_name ?? 'Caragando Nombre...'}</span>
                                <span className='text-bold' style={{ flexShrink: 0, color: 'green', fontSize: '14px' }}>{returnCurrency(objs?.sale_price ?? 0.00, objs?.currency)}</span>
                            </div>

                        </div>
                    ))
                }
            </div>

            <div className='gallery-bc-global' style={{ display: currentOption == 'marcas' ? 'grid' : 'none' }}>
                {
                    listProducts_Brands && (Object.keys(listProducts_Brands ?? {})).map((names) => (
                        <div >
                            <h3 style={{ fontWeight: 'bold' }}>{names}</h3>
                            <div className='gallery-products-global'>
                                {
                                    listProducts_Brands[names].map((objs) => (

                                        <div className='card-product-global shadow-lvl6' onClick={() => handleModal(objs)}>
                                            <div>
                                                <ImagenesGlobal
                                                    url={objs?.img_list.length > 0 ? objs.img_list[0] : null}
                                                    loadImageS={loadImageS}
                                                    type={'picture'}
                                                    key={objs?.code + objs?.company_id}
                                                />
                                            </div>

                                            <div>
                                                <span className='limited-text normal-black'>{objs?.product_name ?? 'Caragando Nombre...'}</span>
                                                <span className='text-bold' style={{ flexShrink: 0, color: 'green', fontSize: '14px' }}>{returnCurrency(objs?.sale_price ?? 0.00, objs?.currency)}</span>
                                            </div>

                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>

            <div className='gallery-bc-global' style={{ display: currentOption == 'categorias' ? 'grid' : 'none' }}>
                {
                    listProducts_Categories && (Object.keys(listProducts_Categories ?? {})).map((names) => (
                        <div >
                            <h3 style={{ fontWeight: 'bold' }}>{names}</h3>
                            <div className='gallery-products-global'>
                                {
                                    listProducts_Categories[names].map((objs) => (

                                        <div className='card-product-global shadow-lvl6' onClick={() => handleModal(objs)}>
                                            <div>
                                                <ImagenesGlobal
                                                    url={objs?.img_list.length > 0 ? objs.img_list[0] : null}
                                                    loadImageS={loadImageS}
                                                    type={'picture'}
                                                    key={objs?.code + objs?.company_id}
                                                />
                                            </div>

                                            <div>
                                                <span className='limited-text normal-black'>{objs?.product_name ?? 'Caragando Nombre...'}</span>
                                                <span className='text-bold' style={{ flexShrink: 0, color: 'green', fontSize: '14px' }}>{returnCurrency(objs?.sale_price ?? 0.00, objs?.currency)}</span>
                                            </div>

                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>

            {loadingGP && <Preloader colorSelected='var(--empresa-color)' />}

            <ModalForAll stateModal={dataModal ? true : false} setStateModal={handleModal} className='modal-detail-products'>
                <ModalViewProduct product={dataModal && dataModal} allProducts={listadoProductos} loadImageS={loadImageS} itsCompany={false} onSelectProduct={handleModal} convertPrice={returnCurrency} />
            </ModalForAll>

            <ModalForAll stateModal={stateModalAddCompany} setStateModal={setStateModalAddCompany} className="modal-login">
                <MyCompanyUpdate closeModal={setStateModalAddCompany}
                    dataCompanyProvider={temporalNewCompany} setDataCompanyProvider={setTemporalNewCompany} reloadData={reloadMyCompanys}
                />
            </ModalForAll>
        </div>
    )
}

export default GlobalProducts